import React, { useEffect } from 'react'

const Addstaff = () => {
    useEffect(() => {
        // Initialize intl-tel-input when the component mounts
        const input = document.querySelector("#mobilebrokerAdd");
        const iti = window.intlTelInput(input, {
            preferredCountries: ["us", "gb", "in", "au"],  // Customize preferred countries
            utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.8/build/js/utils.js"  // For better validation and formatting
        });

        // Cleanup the intl-tel-input when the component unmounts
        return () => {
            if (iti) {
                iti.destroy();
            }
        };
    }, []);
    return (
        <div>
            <div className="modal fade" id="AddstaffModal" tabindex="-1" aria-labelledby="AddstaffLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header" >
                            <h5 className="modal-title font-bold" id="AddstaffLabel">Add Staff </h5>
                            <button type="button" className="btn-close btn-close-primary size-10" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <div className="first-section">
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label for="UserName" className="form-label">User Name (*)</label>
                                        <input type="text" className="form-control" id="UserName" placeholder="Enter Username" />
                                    </div>
                                    <div className="col-md-6">
                                        <label for="password" className="form-label">Password (*)</label>
                                        <input type="text" className="form-control" id="password" placeholder="Enter title" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label for="f_name" className="form-label">First Name (*)</label>
                                        <input type="text" className="form-control" id="f_name" placeholder="Enter title" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label for="f_name" className="form-label">Last Name (*)</label>
                                        <input type="text" className="form-control" id="l_name" placeholder="Enter title" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label for="PhoneNo" className="form-label">Phone No (*)</label>
                                        <input type="text" className="form-control" id="mobilebrokerAdd" placeholder="Enter title" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label for="UserName" className="form-label">User Name (*) </label>
                                        <input type="text" className="form-control" id="UserName" placeholder="Enter title" />
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="response" className="form-label">Status (*)</label>
                                        <select className="form-select" id="response">
                                            <option value="" disabled selected>Select</option>
                                            <option value="NOT INTERESTED">REAl DO</option>
                                            <option value="SAI Branding">SAI Branding</option>

                                            {/* Add other options here */}
                                        </select>
                                    </div>
                                 
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="response" className="form-label">Assign Project (*)</label>
                                        <select className="form-select" id="response">
                                            <option value="" disabled selected>Select</option>
                                            <option value="Lead">SAI Branding</option>
                                            <option value="Client">Real Do</option>
                                           

                                            {/* Add other options here */}
                                        </select>
                                    </div>
                                    <div className="col-md-6 mt-3">
                                        <label htmlFor="response" className="form-label">Role (*)</label>
                                        <select className="form-select" id="response">
                                            <option value="" disabled selected>Select</option>
                                            <option value="Lead">SAI Branding</option>
                                            <option value="Client">Real Do</option>
                                           

                                            {/* Add other options here */}
                                        </select>
                                    </div>

                                    <div className="col-12 mt-3">
                                        <label for="profile" className="form-label">Profile (*)</label>
                                        <input  type='file' className="form-control" id="profile" rows="3"></input>
                                    </div>
                                </div>

                            </div>


                        </div>
                        <div className="modal-footer justify-content-between p-3" style={{ borderTop: "2px solid #f0f0f0" }}>
                            <button
                                type="button"
                                className="btn btn-outline-primary d-flex align-items-center gap-2"
                                style={{ borderRadius: "30px", padding: "0.5rem 1.5rem" }}
                                data-bs-dismiss="modal"
                            >
                                <i className="bi bi-x-circle"></i> Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-gradient d-flex align-items-center gap-2"

                                style={{ borderRadius: "30px", padding: "0.5rem 1.5rem", background: "linear-gradient(90deg, #6a11cb 0%, #313265 100%)", color: "white", border: "none" }}
                            >
                                <i className="bi bi-plus-circle"></i>  Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Addstaff
